import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { COMPANY } from "@/data/content";

const NotFound = () => (
  <section className="relative flex min-h-[85vh] items-center overflow-hidden bg-slate-950 pt-32" data-testid="not-found">
    <div className="pointer-events-none absolute -right-32 top-0 h-96 w-96 rounded-full bg-[color:var(--brand-blue)] opacity-20 blur-3xl" />
    <div className="pointer-events-none absolute -left-24 bottom-0 h-80 w-80 rounded-full bg-[color:var(--brand-red)] opacity-10 blur-3xl" />
    <div className="container-x relative z-10">
      <span className="eyebrow text-slate-300">Error 404</span>
      <h1 className="mt-4 font-[Outfit] text-6xl font-extrabold text-white sm:text-7xl">
        Page not found.
      </h1>
      <p className="mt-5 max-w-xl text-lg text-slate-300">
        The page you&apos;re looking for doesn&apos;t exist or has moved. Let&apos;s get you back to {COMPANY.name}.
      </p>
      <div className="mt-9 flex flex-wrap gap-4">
        <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-[color:var(--brand-red)] px-7 py-3.5 text-base font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5" data-testid="notfound-home">
          <Home className="h-5 w-5" /> Back to Home
        </Link>
        <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-base font-semibold text-white transition-colors duration-200 hover:bg-white hover:text-slate-950">
          <ArrowLeft className="h-5 w-5" /> Contact Us
        </Link>
      </div>
    </div>
  </section>
);

export default NotFound;
